// 데모(체험) 주문 저장소 — 백엔드 없이 localStorage 에 허구 주문을 저장.
// 주문내역 페이지가 일정 시간(TTL) 동안 표시할 수 있게 한다.

const KEY = 'demoOrders';
const SEQ_KEY = 'demoOrderSeq';
const TTL_MS = 30 * 60 * 1000; // 30분

function read() {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) { return []; }
}
function write(arr) {
  try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (_) {}
}

// TTL 이내 활성 주문만 반환 (만료분은 정리)
export function getActiveDemoOrders() {
  const now = Date.now();
  const arr = read().filter(o => now - (o.ts || 0) < TTL_MS);
  write(arr);
  return arr;
}

// 허구 주문번호 (1~999 순환)
function nextOrderNumber() {
  let n = parseInt(localStorage.getItem(SEQ_KEY) || '0', 10) + 1;
  if (!Number.isFinite(n) || n > 999) n = 1;
  try { localStorage.setItem(SEQ_KEY, String(n)); } catch (_) {}
  return n;
}

/**
 * 데모 주문 저장.
 * @param {Array} items - [{ name, name_ko, quantity, price, totalPrice, selectedOptions, itemCode, is_review_benefit }]
 * @param {Object} opts - { isReview }
 * @returns {{orderNumber:number, ts:number, items:Array}}
 */
export function placeDemoOrder(items, opts = {}) {
  const arr = getActiveDemoOrders();
  const orderNumber = nextOrderNumber();
  const order = {
    orderNumber,
    ts: Date.now(),
    isReview: !!opts.isReview,
    items: Array.isArray(items) ? items : [],
  };
  arr.push(order);
  write(arr);
  return order;
}

export function clearDemoOrders() {
  try { localStorage.removeItem(KEY); } catch (_) {}
}

export const DEMO_ORDER_TTL_MS = TTL_MS;
